import { KYMW1000Model } from '../../kymw1000/kymw1000.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * ログイン画面お知らせを取得するサービス
 *
 * @export GetInfomationService
 * @class GetInfomation
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetInfomationService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW1000Model;
  private vo: { forWholeInfo_ColumnName: string };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetInfomationService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ForWholeInfo_ColumnName: this.vo.forWholeInfo_ColumnName
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetInfomationService
   */
  execute(model: KYMW1000Model, vo: { forWholeInfo_ColumnName: string }): void {
    this.model = model;
    this.vo = vo;
    this.send('getInformation', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetUserClientNameService
   */
  success(data: any): void {
    this.model.updateLoginInformation(data);
    this.model.kYMW1000Component.tbx_user.nativeElement.focus();
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetUserClientNameService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
